import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Button,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Sadface from "../../assets/sad-emoji.svg";
import colors from "../../theme/Colours";

interface NoDataDialogProps {
  open: boolean;
  onClose: () => void;
  sadFace?: React.ReactNode;
  message?: string;
  buttonText?: string;
}

const NoDataDialog: React.FC<NoDataDialogProps> = ({
  open,
  onClose,
  sadFace = (
    <img src={Sadface} alt="sad face" style={{ width: 40, height: 40 }} />
  ),
  message = "No Data available for selected range",
  buttonText = "OK",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: " 535px",
          height: "250px",
          p: 2,
          borderRadius: 4,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          p: 1,
          pb: 0,
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          size="small"
          sx={{ ml: "auto" }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <Box sx={{ mb: 1 }}>{sadFace}</Box>
        <Typography
          variant="subtitle1"
          sx={{
            mb: 3,
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          {message}
        </Typography>
        <Button
          variant="contained"
          color="inherit"
          onClick={onClose}
          sx={{
            width: 100,
            fontWeight: 600,
            textTransform: "none",
            borderRadius: 1,
            backgroundColor: colors.primaryButtonOrange,
            color: colors.background2,
          }}
        >
          {buttonText}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default NoDataDialog;
